import { FC, useEffect, useState } from "react"
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core"
import { CartaoCreditoParcelaType, CartaoCreditoType, CartaoType, Clientes, FinanceiraType, FinanciamentoParcela, FinanciamentoSimulacao, PagamentoCartaoType, PedidoPagamento, PedidoType, TiposPagamentoIDType } from "src/types";
import { CollectionUtil } from "src/framework/commons";
import { STATUS_CODE } from "src/framework/providers/api";
import pagamentoProvider from "src/providers/pagamentos/PagamentosProvider";
import { Financeiras } from "../../financiamento/Financeiras";
import { CARTAO_FINANCIAMENTO, DEAFULT_CARTAO } from "src/constants";
import { FullWidthButton } from "src/framework/components/buttons";
import { confirmationDialog } from "src/framework/store";
import { CartaoCredito } from "../../cartao/CartaoCredito";
import { MdAdd } from "react-icons/md";
import { CardCartaoCredito } from "../CartaoAPrazo/CardCartaoCredito";
import "./styles.scss";
import { FaCreditCard } from "react-icons/fa";
import { HeaderFormaPagamento } from "../HeaderFormaPagamento";
import { AiFillBank } from "react-icons/ai";
import { InputMoney } from "src/framework/components/forms";

interface CartaoCreditoFinanciamentoProperties {
    pedido: PedidoType | null;
    onConfirmar: (pagamento: PedidoPagamento, tipoPagamento: TiposPagamentoIDType, fecharPagamento: boolean) => void;
    qtdCartoes?: number;
    qtdParcelas?: number;
}

const CartaoCreditoFinanciamento: FC<CartaoCreditoFinanciamentoProperties> = ({
    pedido,
    onConfirmar,
    qtdParcelas
}) => {
    const [valorPendente, setValorPendente] = useState<number | null>(null);
    const [valorCartaoCredito, setValorCartaoCredito] = useState<number>(-1);
    const [pedidoFinanciamento, setPedidoFinanciamento] = useState<PedidoType | null>(null);
    const [disabledConfirmar, setDisableConfirmar] = useState<boolean>(true);    
    const [pedidoPagamento, setPedidoPagamento] = useState<PedidoPagamento | null>(null);
    const [pagamentoCartaoState, setPagamentoCartaoState] = useState<CartaoCreditoType & PagamentoCartaoType>(DEAFULT_CARTAO);
    const [cartoesCredito, setCartoesCredito] = useState<Array<CartaoCreditoType & PagamentoCartaoType>>([]);
    const [cartaoEdicao, setCartaoEdicao] = useState<number>(-1);
    const [showFinanciamento, setShowFinanciamento] = useState<boolean>(false)
    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const [dadosCliente, setDadosCliente] = useState<Clientes | null>(null);
    
    /** Métodos **/
    const _valorPendente = (): number | null => {
        if (pedido) {
            let valorEmPagamento: number = 0.0;
            const valores: number[] = cartoesCredito.map(c => c.valor_original)
            for (const valor of valores) {
                valorEmPagamento += valor
            }
            return Number(((pedido?.valor_pendente || pedido?.valor_pagamento) - valorEmPagamento).toFixed(2))
        }
        return null;
    }

    const _isValid = () => {
        return !(pagamentoCartaoState.cvc === "" || (pagamentoCartaoState?.cvc as string)?.length < 3 || pagamentoCartaoState.expiry === "" || pagamentoCartaoState.name === "" || pagamentoCartaoState.number === "" || pagamentoCartaoState.parcela === null || pagamentoCartaoState.issuer === "" || pagamentoCartaoState.issuer === "unknow" || !pagamentoCartaoState.is_valid)
    }

     const getDadosCliente = async (): Promise<void> => {
        const response = await pagamentoProvider.obtemClientePedido(String(pedido?.codigo_venda))

        if (response.statusCode === STATUS_CODE.OK) {
            setDadosCliente(response?.data || null);
        }
    }

    const init = async (): Promise<void> => {
        await Promise.all([
            getDadosCliente(),
            setPedidoFinanciamento(CollectionUtil.merge({}, pedido))
        ]);
        const _valor = _valorPendente();
        if (_valor !== null) {
            setValorPendente(Number(_valor))
        }

        const state: CartaoCreditoType & PagamentoCartaoType = { ...pagamentoCartaoState }
        state.codigo_venda = pedido?.codigo_venda;
        state.valor_original = Number(0)
        setValorCartaoCredito(Number(pedido?.valor_pendente || "0"))
        setPagamentoCartaoState(state)
    }

    useEffect(() => {
        (async () => {
            await init()
        })()
        
    }, [])

    useEffect(() => {
        const _valor = _valorPendente();
        if (_valor !== null) {
            setValorPendente(Number(_valor))
        }
    }, [valorCartaoCredito, cartoesCredito])

    const handleKeyUp = (event: any) => {
        if(event.key === 'Escape'){
            setOpenDialog(false);
        }
    }
    return <div className="CartaoCreditoFinanciamento">
        <HeaderFormaPagamento 
            icon={<><FaCreditCard /></>}
            title={<>Cartão de crédito</>}
        />
        <div className="row">
            {valorPendente !== null && valorPendente > 0 && <div className="X12 S6 M4">
                <InputMoney 
                    label="Valor residual"
                    value={valorCartaoCredito}
                    disabled={!valorPendente || (cartoesCredito.length === 1)}
                    onChangeValue={(newValue) => {
                        let _valor = newValue?.numberValue; 
                        setValorCartaoCredito(Number(_valor))
                    }}
                    onBlur={(event: any) => {
                        let _valor: number = Number(Number(String(event?.target?.value || "0,00")?.replace(/\./g, "")?.replace(/\,/g, ".")).toFixed(2)); 
                        if (_valor && _valor > valorPendente || (_valor < valorPendente && cartoesCredito.length > 0)) {
                            _valor = valorPendente;
                        }
                        setValorCartaoCredito(Number(_valor))
                    }}

                />
            </div>}
            <div className="X12">
                {cartoesCredito.map((newValue, index) => {
                    const cartao: CartaoType & { parcela?: CartaoCreditoParcelaType | null } = {
                        numero: newValue?.number?.replace(/\s/g, ""),
                        bandeira: newValue.issuer,
                        valor: newValue?.parcela ? newValue.parcela.total : Number((newValue.parcelas * newValue.valor_parcela).toFixed(2)),
                        nome: newValue.name,
                        cvv: newValue.cvc,
                        mes_expiracao: Number(newValue.expiry.split("/")[0]),
                        ano_expiracao: Number(newValue.expiry.split("/")[1]),
                        parcelas: newValue.parcelas,
                        valor_original: newValue.valor_original,
                        parcela: newValue.parcela,
                        valor_parcela: newValue.valor_parcela

                    }

                    return <CardCartaoCredito
                        key={`cartao-${cartao.numero}`}
                        disableEdit={true}
                        cartao={cartao}
                        onEdit={() => {
                            const state: CartaoCreditoType & PagamentoCartaoType = CollectionUtil.merge({}, pagamentoCartaoState)

                            state.codigo_venda = pedido?.codigo_venda;
                            state.valor_original = Number(cartao?.valor_original || "0")
                            state.cvc = cartao.cvv
                            state.expiry = `${cartao.mes_expiracao}/${cartao.ano_expiracao}`
                            state.issuer = cartao.bandeira
                            state.name = cartao.nome
                            state.number = cartao.numero
                            state.parcelas = cartao.parcelas
                            state.parcela = cartao.parcela
                            state.valor_original = cartao.valor_original
                            state.valor_parcela = cartao.valor
                            state.is_valid = !!cartao.parcela

                            setPagamentoCartaoState(state)
                            setCartaoEdicao(index)
                            setOpenDialog(true);
                        }}
                        onRemove={() => {
                            confirmationDialog.setup({
                                title: "Aviso",
                                content: "Removendo o cartão de crédito será necessário efetuar novamente a simulação caso já efetuada?",
                                onClose: () => {
                                    confirmationDialog.close()
                                },
                                onConfirmation: () => {
                                    const _cartoesCredito: any[] = [...cartoesCredito]
                                    _cartoesCredito.splice(index, 1)
                                    setCartoesCredito(_cartoesCredito)
                                    confirmationDialog.close()
                                    setShowFinanciamento(false)
                                    setDisableConfirmar(true)
                                }
                            })
                            confirmationDialog.open()
                        }}
                    />
                })}
            </div>
        </div>


        {showFinanciamento && <>
            <div className="row">
                <div className="X12">
                    <HeaderFormaPagamento 
                        icon={<><AiFillBank /></>}
                        title={<>Financiamento via plataforma</>}
                        subTitle="Faça a simulação de financiamento"
                        style={{marginTop: "28px"}}
                    />
                </div>
            </div>
            <div className="row">
                <div className="X12 S6 M4">
                    <InputMoney 
                        label="Valor a financiar"
                        value={pedidoFinanciamento?.valor_pagamento}
                        disabled={true}
                    />
                </div>
            </div>
            <Financeiras
                solo={false}
                pedido={pedidoFinanciamento}
                disabledConfirmar={false}
                dadosCiente={dadosCliente}
                onChange={(simulacao: FinanciamentoSimulacao | null, financeira: FinanceiraType | null, parcela: FinanciamentoParcela | null) => {
                    const _cartao = [...cartoesCredito].shift();
                    if (simulacao === null && financeira === null &&  parcela === null) {
                            setPedidoPagamento(null)
                            setDisableConfirmar(true)
                            return;
                    }
                    if (simulacao && pedido && pedidoFinanciamento && financeira && parcela && _cartao) {
                        const cartao: CartaoType = {
                            numero: _cartao.number,
                            bandeira: _cartao.issuer,
                            valor: _cartao?.parcela ? _cartao.parcela.total : Number((_cartao.parcelas * _cartao.valor_parcela).toFixed(2)),
                            nome: _cartao.name,
                            cvv: _cartao.cvc,
                            mes_expiracao: Number(_cartao.expiry.split("/")[0]),
                            ano_expiracao: Number(_cartao.expiry.split("/")[1]),
                            parcelas: _cartao.parcelas,
                            valor_original: _cartao.valor_original,
                            valor_parcela: _cartao.valor_parcela
                        }

                        const _pedidoPagamento: PedidoPagamento = {
                            forma_pagamento: CARTAO_FINANCIAMENTO.id,
                            pedido: pedido.id,
                            itens: {
                                financiamento: [{
                                    financeira: financeira.id,
                                    simulacao: simulacao.simulacao_id,
                                    valor: simulacao.total_liberado,
                                    valor_original: Number(pedidoFinanciamento?.valor_pagamento),
                                    valor_parcela: Number(parcela?.valor_parcela),
                                    valor_entrada: Number(parcela?.valor_entrada),
                                    parcelas: Number(parcela?.parcela),
                                    taxa: Number(parcela?.taxa_juros),
                                    carencia: Number(parcela?.dias_carencia_primeiro_pagamento),
                                }],
                                cartoes_credito: [cartao]
                            }
                        }
                        setPedidoPagamento(_pedidoPagamento)
                        setDisableConfirmar(false)
                    }
                }}
            />
        </>}

        <div className="row">
            {!showFinanciamento && <div className="X12 M6">
                <FullWidthButton
                    text="Adicionar cartão"
                    variant="contained"
                    disableElevation
                    disabled={(valorCartaoCredito === 0 || valorCartaoCredito >= Number(pedido?.valor_pagamento)) || cartoesCredito.length >= 1}
                    color="secondary"
                    onClick={() => {

                        if (valorCartaoCredito !== null) {
                            const state: CartaoCreditoType & PagamentoCartaoType = { ...pagamentoCartaoState }
                            state.codigo_venda = pedido?.codigo_venda;
                            state.is_valid = false;
                            state.valor_original = valorCartaoCredito
                            setPagamentoCartaoState(state)
                            setOpenDialog(true);
                        }
                    }}
                />
            </div>}
            
            <div className={`X12 M6 ${showFinanciamento ? "M--offset6" : ""}`}>
                <FullWidthButton 
                    disabled={disabledConfirmar}
                    text="Confirmar"
                    color="primary"
                    variant="contained"
                    disableElevation
                    onClick={() => {
                        if (pedidoPagamento) {
                            onConfirmar(pedidoPagamento, CARTAO_FINANCIAMENTO.id as any, true)
                        }
                    }}
                />
            </div>
        </div>
        {/* EDIÇÃO DE CARTÕES */}
        <Dialog className={"dialog-edit-cartao"} open={openDialog} maxWidth="lg" onKeyUp={handleKeyUp}>
            <DialogTitle>
            </DialogTitle>
            <DialogContent>
                <CartaoCredito
                    pagamentoCartao={pagamentoCartaoState}
                    entrada={false}
                    solo={false}
                    onChange={(newValue) => {
                        setPagamentoCartaoState(newValue)
                    }}
                    onConfirmar={() => { }}
                    disabledValoPargamento={true}
                    qtdMaxParcelas={qtdParcelas}
                    valorReferencia={Number(_valorPendente())}
                />
            </DialogContent>
            <DialogActions>
                <div className="row actions">
                    <div className="X12 M4">
                        <FullWidthButton 
                            text="Fechar"
                            onClick={()=>{
                                setOpenDialog(false);
                            }}
                        />
                    </div>
                    <div className="X12 M4">
                        <FullWidthButton
                            text="Cancelar"
                            onClick={() => {
                                setOpenDialog(false);
                                setPagamentoCartaoState({ ...DEAFULT_CARTAO, codigo_venda: pedido?.codigo_venda, })
                            }}
                        />
                    </div>
                    <div className="X12 M4">
                        <FullWidthButton
                            text="Salvar"
                            variant="contained"
                            color="primary"
                            disableElevation
                            disabled={!_isValid()}
                            onClick={() => {
                                if (pedido) {
                                    const newValue = pagamentoCartaoState;
                                    const _cartoes = [...cartoesCredito]

                                    _cartoes[0] = newValue;
                                    if (pedidoFinanciamento) {
                                        const _statePedidoFinanciamento = CollectionUtil.merge({}, pedidoFinanciamento);
                                        _statePedidoFinanciamento.valor_pagamento = Number((Number(pedido.valor_pagamento) - valorCartaoCredito).toFixed(2));
                                        setPedidoFinanciamento(_statePedidoFinanciamento)
                                    }
                                    setCartoesCredito(_cartoes)
                                    setShowFinanciamento(true)
                                }

                                
                                setOpenDialog(false);
                                setPagamentoCartaoState({ ...DEAFULT_CARTAO });
                                setCartaoEdicao(-1)
                            }}
                        />
                    </div>
                </div>
            </DialogActions>

        </Dialog>
    </div>
}

export { CartaoCreditoFinanciamento }